// "Austin, TX, USA" without stray commas when some fields are blank
export function formatLocation(user) {
  return [user?.city, user?.state, user?.country]
    .map(part => (part || "").trim())
    .filter(Boolean)
    .join(", ");
}
